"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertiesToI18nEntry = exports.jsonToI18nBundle = exports.csvToI18nBundle = void 0;
var csv_1 = require("./csv");
Object.defineProperty(exports, "csvToI18nBundle", { enumerable: true, get: function () { return csv_1.csvToI18nBundle; } });
var json_1 = require("./json");
Object.defineProperty(exports, "jsonToI18nBundle", { enumerable: true, get: function () { return json_1.jsonToI18nBundle; } });
var properties_1 = require("./properties");
Object.defineProperty(exports, "propertiesToI18nEntry", { enumerable: true, get: function () { return properties_1.propertiesToI18nEntry; } });
//# sourceMappingURL=index.js.map